module.exports = __webpack_public_path__ + "img/club_06.190ac4ab.png";